import * as _ from 'lodash';

import { ActivatedRouteSnapshot } from '@angular/router';

import { ConfigService } from './../../core/services/config.service';
import { Injectable } from '@angular/core';
import { LmsEventDetails } from './../../core/model/lms-event-details.model';
import { Tab } from '../../core/model/tab.model';
import { TabService } from './../../core/services/tab.service';

/**
 * @export
 * @class LocoDataResolver
 * @implements {Resolve<Tab>}
 */
@Injectable()
export class HelpDocsResolver  {
    constructor(
        private tabService: TabService,
        private configService: ConfigService
    ) { }

    /**
     * Routing Resolver
     * @param {ActivatedRouteSnapshot} route
     * @returns
     * @memberOf LocoDataResolver
     */
    resolve(route: ActivatedRouteSnapshot) {
        let tab = this.tabService.getTabById(Math.abs(route.params['tabid']))[0];

        let tabType = this.configService.getConfigData().tab.event.update;
        if (!tab) {
            tabType = this.configService.getConfigData().tab.event.add;
            tab = { description: '' };
        }

        if (!(tab.subTypeDetail && tab.subTypeDetail.data && tab.subTypeDetail.data.status)) {
            if (!tab.subTypeDetail) {
                tab.subTypeDetail = {};
            }
            tab.subTypeDetail['data'] = {
                message: '',
                status: 'blank'
            };
        }

        tab.type = 'Help Documents';
        tab.subType = 'Data';


        if (tabType === this.configService.getConfigData().tab.event.add) {
            tab.id = route.params['tabid'];
            return this.tabService.notifyChange(<LmsEventDetails>({
                type: tabType,
                data: tab
            }));
        } else {
            this.tabService.notifyChange(<LmsEventDetails>({
                type: tabType,
                data: tab
            }));
        }

        return this.tabService.getTabById(Math.abs(route.params['tabid']));

    }
}
